<template>
  <q-chat-message
    class="c-chat-message --system"
    :text="chat.text"
    :stamp="chat.stamp"
    :sent="chat.sent"
  >
    <template #avatar>
      <q-avatar class="c-chat-avatar">
        <img src="/images/icons/catwise-badge.svg" />

        <c-tooltip>Catwise</c-tooltip>
      </q-avatar>
    </template>
  </q-chat-message>
</template>

<script setup>
// Define props for the chat component
const props = defineProps({
  chat: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});
</script>

<style lang="scss">
.q-message.c-chat-message.--system {
  @apply tw-flex tw-max-w-[70%] tw-gap-4 tw-self-start;

  .q-avatar.c-chat-avatar {
    @apply tw-bg-aqua-100;
  }

  .q-avatar__content > img {
    @apply tw-h-[16px];
  }

  .q-message-text {
    &.q-message-text--received {
      @apply tw-bg-aqua-100 tw-text-gray-800;
    }
  }
}
</style>
